import React from "react";
// material-ui components
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import Grid from "@material-ui/core/Grid";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import TextField from "@material-ui/core/TextField";
// @material-ui/icons
import Close from "@material-ui/icons/Close";
// core components
import Button from "components/CustomButtons/Button.js";

import Sign from "assets/img/barricade.svg";
import modalStyles from "assets/jss/elite-feats-cms/modalStyle.js";
import SweetAlert from "react-bootstrap-sweetalert";
import { css } from "@emotion/react";
import * as Yup from "yup";
import axios from "axios";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { withRouter } from "react-router-dom";
import { Divider, Typography } from "@material-ui/core";
import BarLoader from "react-spinners/BarLoader";
import alertStyles from "assets/jss/elite-feats-cms/views/sweetAlertStyle.js";
import { useTranslation } from "react-i18next";

const styles = { ...modalStyles, ...alertStyles };
const useStyles = makeStyles(styles);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default function Modal(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
  `;

  return (
    <div>
      <Dialog
        fullScreen
        classes={{
          root: classes.center,
          paper: classes.modal,
        }}
        open={props.open}
        transition={Transition}
        keepMounted
        onClose={() => props.setOpen(false)}
        aria-labelledby="modal-slide-title"
        aria-describedby="modal-slide-description"
      >
        <DialogContent
          id="modal-slide-description"
          className={classes.modalBody}
          style={{
            marginBottom: 10,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <img src={Sign} style={{ width: 100, marginBottom: 20 }} />

          <Typography
            align="justify"
            style={{
              marginTop: 15,
              fontSize: 18,
              color: "#4d4e50",
              fontWeight: 900,
            }}
          >
            {t("common:accountHoldMessage")}{" "}
            <span style={{ color: "#037593" }}>{t("common:supportEmail")}</span>
          </Typography>
        </DialogContent>
        <DialogActions
          className={`${classes.modalFooter} ${classes.modalFooterCenter}`}
          style={{
            display: "flex",
            justifyContent: "center",
            paddingBottom: 10,
            paddingTop: 10,
            borderTop: "1px solid #dedede",
          }}
        >
          <Button
            style={{ marginRight: 10 }}
            onClick={() => {
              props.setOpen(false);
              props.setRedirectToLogin(true);
            }}
          >
            {t("common:okButton")}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
